













import { Component, Prop, Vue } from "vue-property-decorator";
import { readEntryByLabel } from "@/store/uniabc/getters";
import { api } from "@/api";
import { readGitLabInfo } from "@/store/gitlab/getters";
import { dispatchSetEntryImageUrl } from "@/store/uniabc/actions";
import { dispatchRaiseErrorTimeout } from "@/store/appState/actions";

@Component
export default class SetImage extends Vue {
  @Prop(String) readonly label!: string;
  private selectedImageUrl = readEntryByLabel(this.$store)(this.label)
    .image_url;
  private images: string[] = [];
  private loading = true;

  private async mounted() {
    this.loading = true;
    const gitlab = readGitLabInfo(this.$store);
    try {
      this.images = (
        await api.getImageUrls(gitlab.projectId, gitlab.branch)
      ).map(i => i.path);
    } catch (e) {
      await dispatchRaiseErrorTimeout(
        this.$store,
        new Error(`Unable to fetch Image URLs:<br>${e}`)
      );
    }
    this.loading = false;
  }

  private async save() {
    await dispatchSetEntryImageUrl(this.$store, {
      label: this.label,
      imageUrl: this.selectedImageUrl
    });
  }

  private clear() {
    this.selectedImageUrl = "";
    this.save();
  }
}
